module.exports = __webpack_public_path__ + "img/work-from-home.531e17df.png";